import { type ThemeOptions, createTheme } from '@mui/material/styles';

const fontWeight = {
  thin: 100,
  extraLight: 200,
  light: 300,
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
  extraBold: 800,
  black: 900,
};

const letterSpacing = {
  tighter: '-0.5px',
  tight: '-0.25px',
  normal: '0px',
  wide: '0.25px',
  wider: '0.5px',
};

const textVariants = {
  h1: {
    fontSize: 32,
    fontWeight: fontWeight.semiBold,
    lineHeight: 1.375, // 44px
    letterSpacing: letterSpacing.tight,
  },
  h2: {
    fontSize: 28,
    fontWeight: fontWeight.semiBold,
    lineHeight: 1.5, // 42px
    letterSpacing: letterSpacing.tight,
  },
  h3: {
    fontSize: 24,
    fontWeight: fontWeight.semiBold,
    lineHeight: 1.5, // 36px
    letterSpacing: letterSpacing.normal,
  },
  h4: {
    fontSize: 20,
    fontWeight: fontWeight.semiBold,
    lineHeight: 1.5, // 30px
    letterSpacing: letterSpacing.normal,
  },
  h5: {
    fontSize: 18,
    fontWeight: fontWeight.semiBold,
    lineHeight: 1.556, // 28px
    letterSpacing: letterSpacing.normal,
  },
  body1: {
    fontSize: 16,
    lineHeight: 1.75, // 28px
    letterSpacing: letterSpacing.normal,
  },
  body2: {
    fontSize: 14,
    lineHeight: 1.71428571, // 24px
    letterSpacing: letterSpacing.normal,
  },
  caption: {
    fontSize: 12,
    lineHeight: 1.5, // 18px
    letterSpacing: letterSpacing.normal,
  },
};

const typography: ThemeOptions['typography'] = {
  fontFamily: [
    '"Sarabun"',
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Roboto',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(','),
  fontSize: 16,
  ...textVariants,
  body1Semibold: {
    ...textVariants.body1,
    fontWeight: fontWeight.semiBold,
  },
  body2Semibold: {
    ...textVariants.body2,
    fontWeight: fontWeight.semiBold,
  },
  button: {
    ...textVariants.body2,
    fontWeight: fontWeight.semiBold,
    textTransform: 'initial',
  },
  captionSemibold: {
    ...textVariants.caption,
    fontWeight: fontWeight.semiBold,
  },
  captionBold: {
    ...textVariants.caption,
    fontWeight: fontWeight.bold,
  },
};

const theme = createTheme({ typography });

export { typography };
export default theme.typography;
